module.exports = {"archivedTransactions":"Archived transactions"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/SearchResultsCustomer/locales/fr.json
// module id = 1426
// module chunks = 0